import Image from "next/image";
import MenuIcon from '/public/images/menu.svg';
import {useEffect, useState} from "react";
import {getColor} from "@/styles/ThemeConfig";
import styled from "styled-components";
import ArrowDownIcon from 'public/images/ar_down.svg'
import ArrowDownActiveIcon from 'public/images/ar_up.svg'
import CloseIcon from 'public/images/close_green.svg'
import Link from "next/link";
import SliderArrowRightGreenIcon from '/public/images/slider_arrow_right_green.svg'
import LocationPinIcon from "../../../public/images/ic-pin.svg";
import SelectSearchLocation from "@/components/inputs/SelectSearchLocation";
import {useRouter} from "next/router";
import NewIcon from "../../../public/images/new.svg";
import CustomDropdownHeaderMobile from "@/components/other/CustomDropdownHeaderMobile";
import ForceSSRLink from "@/components/other/ForceSSRLink";

const LinkItem = styled.div`
    font-size: 14px;
    margin: 0;
    cursor: pointer;
    letter-spacing: 1px;
    color:${getColor('greenText')};
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap:5px;
    :hover{
        color:${getColor('gold')};
    }
`;

const LinkItemLink = styled(ForceSSRLink)`
    text-decoration: none;
    font-size: 14px;
    margin: 0;
    cursor: pointer;
    letter-spacing: 1px;
    color:${getColor('greenText')};
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap:5px;
    :hover{
        color:${getColor('gold')};
    }
`;

const SocialLink = styled.a`
    width: 40px;
    height: 40px;
    
    display: flex;
    justify-content:center;
    align-items:center;
    transition: 0.3s ease;
    
    :hover{
        background-color: rgba(0,0,0,0.5);
    }
`
const CountryList = styled.ul`
    column-width: 200px; /* Each column will be around this width */
    column-gap: 20px; /* Spacing between columns */
    //max-height: 200px; /* Limit the height */
    list-style: none; /* Remove bullet points */
    padding-left: 0; /* Remove default padding */
    //display: flex;
    //flex-wrap:wrap;
    li {
        break-inside: avoid; /* Prevent continent or country from being split between columns */
        margin-bottom: 0px; /* Add spacing between list items */
    }
`;



const HeaderWrapper = styled.div`
    position: fixed;
    width: 100%;
    z-index: 1000;
    top: 0;
    ${({ isMenuOpen, isScrollingUp }) => !isMenuOpen && `
        transform: ${isScrollingUp ? 'translateY(0)' : 'translateY(-100%)'};
        transition: transform 0.3s ease;
    `}
`;


export default function HeaderMobile({regions, headerData, socialLinks, searchOptions, dropdownData})
{

    const [showMenu, setShowMenu] = useState(false);
    const [showRegions, setShowRegions] = useState(false);
    const [showCountry, setShowCountry] = useState(false);
    const [showCities, setShowCities] = useState(false);
    const [isScrollingUp, setIsScrollingUp] = useState(true);

    // Detect scroll direction
    useEffect(() => {
        if (typeof window === 'undefined') return; // Prevents errors during SSR/ISR

        let lastScrollTop = 0;

        const handleScroll = () => {
            const currentScrollTop = window.pageYOffset;
            if (currentScrollTop > lastScrollTop) {
                setIsScrollingUp(false); // Scrolling down
            } else {
                setIsScrollingUp(true);  // Scrolling up
            }
            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    function handleSetShowCities(country){
        setShowCities(country?.cities);
        setShowRegions(false);
    }

    const router = useRouter();
    useEffect(() => {
        const handleRouteChange = () => {
            closeAll();
        };

        // Listen to route changes
        router.events.on('routeChangeStart', handleRouteChange);

        // Cleanup the event listener on component unmount
        return () => {
            router.events.off('routeChangeStart', handleRouteChange);
        };
    }, [router]);

    const closeAll = () => {
        setShowMenu(false);
        setShowRegions(false);
        setShowCountry(false);
        setShowCities(false);
    };

    return <HeaderWrapper isScrollingUp={isScrollingUp} isMenuOpen={showMenu}>
        {/* MAIN BAR    */}
        <div style={{
                background: 'white',
                padding: '14px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'background 0.5s ease', // Add transition for the slide effect
            }}>
                <ForceSSRLink href={'/'}>
                    <Image
                        priority
                        loading={'eager'}
                        src={headerData?.logo?.url}
                        alt={headerData?.logo?.alt ?? headerData?.logo?.name}
                        width={200}
                        height={50}
                        style={{
                            width: '200px',
                            height: 'auto',
                        }}
                    />
                </ForceSSRLink>

                <Image
                    loading={'eager'}
                    src={MenuIcon}
                    alt={'Menu'}
                    onClick={() => setShowMenu(!showMenu)}
                />
        </div>


        {/* OPENED MENU    */}
        <div style={{
            backgroundColor: getColor('grayBackground'),
            position: 'fixed',
            top: 0,
            zIndex: '9999',
            width: '100vw',
            height: showMenu ? 'calc(100vh)' : '0px',
            transition: 'height 0.5s ease,padding 0.5s ease', // Add transition for the slide effect
            overflow: 'hidden',
            overflowY:'scroll'
        }}>

            <div style={{
                background: getColor('grayBackground'),
                padding: '14px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'background 0.5s ease', // Add transition for the slide effect
            }}>
                <ForceSSRLink href={'/'} prefetch={false}>
                    <Image
                        src={headerData?.logo?.url}
                        alt={headerData?.logo?.alt ?? headerData?.logo?.name}
                        width={200}
                        height={100}
                        style={{
                            width: '200px',
                            height: 'auto',
                        }}
                    />
                </ForceSSRLink>

                <Image src={CloseIcon} alt={'Close Menu'} onClick={() => setShowMenu(!showMenu)}/>
            </div>




            {/*BASE*/}
            {
                !showRegions && !showCities && <>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                        padding: '15px',
                        transition: 'height 0.5s ease,padding 0.5s ease', // Add transition for the slide effect
                    }}>
                        <SelectSearchLocation size={"small"} searchOptions={searchOptions}/>

                        {dropdownData && <CustomDropdownHeaderMobile items={dropdownData} setShowMenu={setShowMenu} />}

                        <LinkItem onClick={() => setShowRegions(true)}>
                            DESTINATIONS
                            <Image style={{
                                transform: 'rotate(-90deg)',
                                width: '10px',
                                height: '10px',
                            }} src={ArrowDownIcon} alt={'>'}/>
                        </LinkItem>
                        <LinkItemLink prefetch={false} href={'/private-bookings'}>PRIVATE TOURS</LinkItemLink>
                        <LinkItemLink prefetch={false} href={'/buy-gift'}>GIFT CARDS</LinkItemLink>
                        <LinkItemLink prefetch={false} href={'https://www.secretfoodtours.com/blog'}>BLOG</LinkItemLink>
                        <LinkItemLink prefetch={false} href={'/read-about-us'}>ABOUT US</LinkItemLink>
                        <LinkItemLink prefetch={false} href={'https://www.secrettours.com/'} target={'_blank'} style={{
                            color: getColor('blue'),
                        }}>HISTORICAL TOURS</LinkItemLink>
                    </div>


                    <div style={{
                        width: '100vw',
                        bottom: 0,
                        borderTop: `1px solid ${getColor('divider')}`,
                    }}>
                        <div style={{
                            padding: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                        }}>
                            {socialLinks?.map((item, index) => {
                                return <SocialLink
                                    key={index}
                                    style={{}}
                                    href={item?.url ?? '#'}
                                    target={'_blank'}
                                >
                                    <Image key={index} width={25} height={25} src={item?.darkImage?.url}
                                           alt={item?.darkImage?.alt ?? item?.darkImage?.name}
                                           style={{
                                               width: 'auto',
                                               height: 'auto',
                                           }}/>
                                </SocialLink>

                            })}
                        </div>
                    </div>
                </>
            }

            {/*REGIONS*/}
            <div style={{padding: '15px'}}>
                {
                    showRegions && <div>
                        <div
                            onClick={() => setShowRegions(false)}
                            style={{
                                color: getColor('greenText'),
                                marginBottom: '20px',
                                fontSize: '16px',
                            }}
                        >
                            <Image
                                src={SliderArrowRightGreenIcon}
                                alt={'<'}
                                style={{
                                    transform: 'rotate(180deg)',
                                }}
                            /> DESTINATIONS
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                            }}
                        >
                            {regions?.map((item, index) => (
                                <div
                                    key={index}
                                >
                                    <div
                                        onClick={() => setShowCountry(showCountry === item?.id ? null : item?.id)}
                                        key={index}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: '5px',
                                        }}>
                                            <div style={{
                                                fontSize: '16px',
                                                textTransform: 'uppercase',
                                                color: getColor(showCountry === item?.id ? 'gold' : 'lightGreen')
                                            }}>{item?.name}</div>
                                            <Image width={40} height={40} src={item?.navigationIcon?.url}
                                                   alt={item?.name}/>
                                        </div>

                                        {
                                            showCountry === item?.id ?
                                                <Image style={{
                                                    width: '12px',
                                                    height: '12px',
                                                }} src={ArrowDownActiveIcon} alt={'>'}/>
                                                :
                                                <Image style={{
                                                    width: '12px',
                                                    height: '12px',
                                                }} src={ArrowDownIcon} alt={'>'}/>
                                        }

                                    </div>


                                    <CountryList>
                                        {
                                            showCountry === item?.id && item?.countries?.map((item, index) => {
                                                return <li key={index} onClick={() => handleSetShowCities(item)}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                        marginBottom: '10px',
                                                        fontSize: '18px',
                                                    }}>
                                                        <Image
                                                            src={item?.flag?.url ?? LocationPinIcon?.src}
                                                            alt={item?.label}
                                                            width={20}
                                                            height={20}
                                                            style={{
                                                                width: '20px',
                                                                height: 'auto',
                                                            }}
                                                        />
                                                        {item?.name}
                                                        {item?.isNew && <Image src={NewIcon} alt={'NEW'}/>}
                                                    </div>


                                                </li>
                                            })
                                        }
                                    </CountryList>

                                </div>
                            ))}
                        </div>


                    </div>
                }
            </div>
            {/*    END REGIONS */}

            {/*    CITIES*/}
            {
                showCities && <div style={{padding: '15px'}}>
                    <div
                        onClick={() => setShowRegions(true) & setShowCities(false)}
                        style={{
                            color: getColor('greenText'),
                            marginBottom: '20px',
                            fontSize: '16px',
                        }}
                    >
                        <Image
                            src={SliderArrowRightGreenIcon}
                            alt={'<'}
                            style={{
                                transform: 'rotate(180deg)',
                            }}
                        /> DESTINATIONS
                    </div>
                    <div>
                        {
                            showCities?.map((item, index) => {
                                return <ForceSSRLink
                                    prefetch={false}
                                    key={index}
                                    href={item?.slug ?? '#'}
                                    style={{
                                        color:getColor('greenText'),
                                        fontSize:'18px',
                                        textDecoration:'none',
                                        display:'flex',
                                        alignItems:'center',
                                        gap:'5px',
                                        marginBottom:'5px',
                                    }}
                                    onClick={() => closeAll()}
                                >
                                    {item?.name}
                                    {item?.isNew && <Image src={NewIcon} alt={'NEW'}/>}
                                </ForceSSRLink>
                            })
                        }
                    </div>
            </div>
            }

            {/*    END CITIES*/}


        </div>


    </HeaderWrapper>
}
